'use strict';

import barba from '@barba/core';

const init = () => {
    document.querySelectorAll('.tc-website-projecttagsitem, .tc-website-tagslistitem').forEach((tag) => {
        tag.addEventListener('click', (event) => {
            event.preventDefault()


            if (tag.dataset.serviceUri) {
                sessionStorage.setItem('selectedFilters', JSON.stringify({
                    'businessArea': {
                        'label': tag.innerText.trim(),
                        'value': tag.dataset.uriPathSegment
                    },
                    'service': {
                        'label': tag.dataset.serviceLabel,
                        'value': tag.dataset.serviceUri,
                    }
                }))
            } else {
                sessionStorage.removeItem('selectedFilters')
                sessionStorage.setItem('selectedTag', tag.dataset.uriPathSegment)
            }

            sessionStorage.setItem('keepData', 'true')

            fetch(tag.dataset.uri).then((response) => {
                if (response.ok) {
                    barba.go(response.url || tag.dataset.uri)
                }
            })
        })
    })
}

export default {init}
